import React from 'react'
import Page from 'contexts/page'
import Hero from './content/hero'
import Tutorial from 'components/tutorial'
import InsightsPageContent from './content'

const InsightsPage = ({ upgradable, ...props }) => (
    <Page
        view="insights"
        title={{
            id: 'noun_insights',
            defaultMessage: 'Insights'
        }}
        upgrade={{
            enabled: upgradable,
            content: (
                <>
                    <Hero salt="insights" />
                    <Tutorial
                        which="insights"
                        upgrade={{ module: 'insights' }} />
                </>
            )
        }}>
        <InsightsPageContent {...props} />
    </Page>
)

export default InsightsPage